import React, { useEffect } from 'react';
import { Card, Form, Button, Input, Divider, message, Row, Col, Modal, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Parent from './parent';
import Helmet from '../common/helmet';
import { role } from '../../helpers/functions';
import { ROLE_NAME } from '../../helpers/constant';
import { useState } from 'react';
import VerifiedOTPModal from '../common/modal/verifiedOTPModal';
import RadioButtonImage from '../common/radioButtonImage';
import expertSignupChoice from '../../assets/images/Expert-signup-img.jpg';
import clientSignupChoice from '../../assets/images/Client-signup-img.png';
import usericon from '../../assets/images/email-logo.png';
import linkedin from '../../assets/images/linkedin.png';
import signupimg from '../../assets/images/signupimg.png';
import signupemaillinkedin from '../../assets/images/signupemaillinkedinimg.png';
import googleLogo from '../../assets/images/google_logo.svg';
import { use } from 'react';
import useResponsive from '../../hooks/useBreakpoint';
import { LinkedinFilled, LinkedinOutlined, MailFilled } from '@ant-design/icons';

const Login = props => {
  const dispatch = useDispatch();
  const {
    isLoginLoading,
    loginMsg,
    loginData,
    google_auth_redirect_url,
    linkedin_auth_redirect_url,
  } = useSelector(state => state.auth);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const [showModal, setShowModal] = useState(false);
  const [loginType, setLoginType] = useState(null);
  const [isSignupToggle, setIsSignupToggle] = useState(false);
  const [loadingGoogleBtn, setLoadingGoogleBtn] = useState(false);
  const [multiFactorAuth, setMultiFactorAuth] = useState(false);
  const [loginCredentials, setLoginCredentials] = useState(null);
  const onFinish = values => {
    setLoginCredentials(values);
    dispatch({ type: 'LOGIN_REQUEST', formData: values });
  };
  useEffect(() => {
    if (query.get('getStarted')) {
      setIsSignupToggle(true);
    }
    // console.log(query.get('getStarted'));
  }, []);
  const onFinishFailed = errorInfo => {};

  useEffect(() => {
    setLoginType(query.get('type'));
  }, [isSignupToggle, search]);
  useEffect(() => {
    if (!isLoginLoading && loginData?.mfa_enable && loginMsg != 'success' ) {
      setMultiFactorAuth(true);
      return;
    }
    if (!isLoginLoading && loginMsg === 'success') {
      dispatch({ type: 'CLEAR_LOGIN_DATA' });
      if (localStorage.getItem('redirectLink')) {
        let tmoURL = localStorage.getItem('redirectLink');
        localStorage.removeItem('redirectLink');
        window.location.href = tmoURL;
      } else {
        if (role() === ROLE_NAME.ADMIN) {
          window.location.href = '/admin/requests';
        } else if (role() === ROLE_NAME.EXPERT) {
          window.location.href = '/dashboard/expert/request';
        } else {
          window.location.href = '/dashboard/customer';
        }
      }
    } else if (!isLoginLoading && loginMsg === 'not-verified') {
      message.error('Please verified your email address');
      setShowModal(true);
    } else if (google_auth_redirect_url) {
      // Get screen width and height
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const width = 800;
      const height = 600;
      // Calculate left and top positions for centering
      const left = (screenWidth - width) / 2;
      const top = (screenHeight - height) / 2;
      const windowFeatures = `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=yes`;

      // window.open(google_auth_redirect_url, 'MiniBrowser', windowFeatures);

      // window.addEventListener('message', handleMiniWindowMessage);

      dispatch({ type: 'CLEAR_LOGIN_DATA' });
    } else if (!isLoginLoading && loginMsg == 'error') {
      message.error(loginData?.message || 'Invalid email or password');
    }
  }, [isLoginLoading, loginMsg, loginData, google_auth_redirect_url]);

  const SIGNUP_TYPES = [
    {
      value: 'expert',
      img: expertSignupChoice,
      label: 'Expert',
    },
    {
      value: 'customer',
      img: clientSignupChoice,
      label: 'Client',
    },
  ];
  const SIGN_UP_TYPE_MODE = [
    {
      value: 'linkedin',
      img: linkedin,
      label: 'Linkedin',
    },
    {
      value: 'email_password',
      img: usericon,
      label: 'Email',
    },
  ];
  const [btnlist, setBtnList] = useState(SIGNUP_TYPES);
  const [modetype, setModeType] = useState('');
  const handleGoogleBtnClick = () => {
    setLoadingGoogleBtn(true);
    dispatch({ type: 'GOOGLE_REDIREACT_URL_GET' });
  };
  const handleLinkedIn = () => {
    dispatch({ type: 'LINKEDIN_REDIREACT_URL_GET', formData: { type: loginType || 'customer' } });
  };
  const handleMiniWindowMessage = event => {
    // Ensure the message is from the mini window
    if (event.origin !== window.location.origin) return;

    // Handle the message
    const windowRes = JSON.parse(event.data);

    if (windowRes) {
      if (windowRes?.success && windowRes?.data?.email) {
        const data = windowRes?.data;
        if (data?.token) {
          dispatch({ type: 'LOGIN_REQUEST', formData: data });
        } else if (loginType === 'customer') {
          window.location.href =
            '/signup?email=' +
            (data?.email || '') +
            '&first_name=' +
            (data?.first_name || '') +
            '&last_name=' +
            (data?.last_name || '');
        } else {
          window.location.href =
            '/expert/signup?email=' +
            (data?.email || '') +
            '&first_name=' +
            (data?.first_name || '') +
            '&last_name=' +
            (data?.last_name || '');
        }
      } else {
        message.error({
          content: windowRes?.message || 'Please try again.',
          className: 'error-class',
        });
      }
    } else {
      message.error({
        content: 'Something went wrong please try again.',
        className: 'error-class',
      });
    }
    setLoadingGoogleBtn(false);
    cleanup();
  };

  const cleanup = () => {
    // Remove event listener when the mini window closes
    window.removeEventListener('message', handleMiniWindowMessage);
  };
  const [otp, setOtp] = useState('');
  const handleSubmit = async () => {
    if (otp === '' || otp.length !== 6) {
      message.error('Please enter a valid OTP');
      return;
    }

    const values = {
      ...loginCredentials,
      otp,
    };
    dispatch({ type: 'LOGIN_REQUEST_MFA', formData: values });
  };
  useEffect(() => {
    if (linkedin_auth_redirect_url) {
      window.location.href = linkedin_auth_redirect_url;
    }
  }, [linkedin_auth_redirect_url]);

  const breakpoint = useResponsive();
  const navigate = useNavigate();
  // useEffect(() => {
  //   if(query.get('type')){
  //     setBtnList(SIGN_UP_TYPE_MODE);
  //   }
  // },[])

  return (
    <Parent isSignupToggle={isSignupToggle}>
      <Helmet title="Login" />
      <Row
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90vh',
          minHeight: '90vh',
        }}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{
            height: '90%',
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
          }}
          className="login-signup-page"
        >
          <Card
            bordered={false}
            style={{
              height: '100%',
              width:
                (breakpoint === 'lg' && '30%') ||
                (breakpoint === 'xl' && '30%') ||
                (breakpoint === 'xxl' && '30%') ||
                '80%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isSignupToggle ? (
              // Signup form
              <article
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <p className="m-title">Sign Up {btnlist[0].value == 'linkedin' ? 'with' : 'as'} </p>

                <RadioButtonImage
                  setCurrentValue={btnlist[0].value == 'linkedin' ? setModeType : setLoginType}
                  buttonList={btnlist}
                  loginType={query.get('type')}
                ></RadioButtonImage>

                <Link
                // to={loginType === 'customer' ? '/signup' : '/expert/signup'}
                >
                  <Button
                    style={{ marginBottom: '24px' }}
                    disabled={!loginType && !modetype}
                    type="primary"
                    htmlType="submit"
                    className="w100"
                    size="large"
                    onClick={() => {
                      setBtnList(SIGN_UP_TYPE_MODE);
                      if (loginType && modetype) {
                        if (modetype === 'linkedin') {
                          handleLinkedIn();
                        } else if (modetype === 'email_password') {
                          navigate(loginType === 'customer' ? '/signup' : '/expert/signup');
                        }
                      }
                    }}
                  >
                    Sign Up
                  </Button>
                </Link>

                {/* <Button
                      style={{ marginBottom: '24px' }}
                      htmlType="button"
                      className="w100"
                      size="large"
                      disabled={!loginType}
                      onClick={handleGoogleBtnClick}
                    >
                      <img src={googleLogo} style={{ width: '30px', height: '30px', marginRight: '5px' }} alt="" />

                      Continue with Google
                    </Button> */}
                <div className="mt8 tc">
                  <p>
                    Have an account?{' '}
                    <span
                      onClick={() => {
                        setIsSignupToggle(false);
                        setLoginType(query?.get('type'));
                      }}
                      style={{ color: '#478bff', cursor: 'pointer' }}
                    >
                      Log In
                    </span>
                  </p>
                </div>
              </article>
            ) : (
              // Login form
              <article
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  //  backgroundColor:"red"
                }}
              >
                <p
                  className="m-title"
                  style={{
                    // height: '13%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {loginType === 'expert' ? 'Expert Login' : 'Client Login'}
                </p>

                <Form
                  layout="vertical"
                  name="basic"
                  hideRequiredMark={true}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  style={{
                    // height: '87%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2vh',
                    width: '100%',
                  }}
                >
                  <Form.Item
                    label="Email address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter email address',
                      },
                      {
                        type: 'email',
                        message: 'Please enter valid email address',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Email address" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter password',
                      },
                    ]}
                  >
                    <Input.Password size="large" placeholder="••••••••••" />
                  </Form.Item>

                  <Form.Item name="remember" valuePropName="checked" className="tr">
                    <Link to="/forget-password" className="b500">
                      Forgot Password?
                    </Link>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      htmlType="submit"
                      className="w100"
                      size="large"
                      loading={isLoginLoading}
                      disabled={isLoginLoading}
                    >
                      <MailFilled />
                      Continue with Email
                    </Button>
                    <Divider style={{}} />
                    <Button
                      type="primary"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      className="w100"
                      size="large"
                      onClick={() => handleLinkedIn()}
                    >
                      <LinkedinFilled />
                      <span>Continue with LinkedIn</span>
                    </Button>
                  </Form.Item>

                  {/* <Button
                        style={{ marginBottom: '24px' }}
                        htmlType="button"
                        className="w100"
                        size="large"
                        loading={loadingGoogleBtn}
                        disabled={loadingGoogleBtn}
                        onClick={handleGoogleBtnClick}
                      >
                        <img src={googleLogo} style={{ width: '30px', height: '30px', marginRight: '5px' }} alt="" />

                        Continue with Google
                      </Button> */}

                  <div className="mt8 tc">
                    <p>
                      Don't have an account yet?{' '}
                      <span
                        onClick={() => {
                          setIsSignupToggle(true);
                          setLoginType();
                        }}
                        style={{ color: '#478bff', cursor: 'pointer' }}
                      >
                        Sign Up
                      </span>
                    </p>
                  </div>
                </Form>
              </article>
            )}
          </Card>
          {(breakpoint == 'xxl' || breakpoint == 'xl' || breakpoint == 'lg') && (
            <Card
              bordered={false}
              style={{
                height: '100%',
                width:
                  (breakpoint === 'lg' && '60%') ||
                  (breakpoint === 'xl' && '45%') ||
                  (breakpoint === 'xxl' && '45%') ||
                  '80%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                //  backgroundColor:"red"
              }}
              className="login-signup-img"
            >
              {(breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === 'xxl') &&
                !isSignupToggle && (
                  <div
                    className="login-side-img-container"
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',

                      // paddingLeft: '6vw',
                    }}
                  >
                    {!isSignupToggle ? (
                      loginType === 'expert' ? (
                        <div style={{ width: '100%', height: '100%' }}>
                          <img
                            src={expertSignupChoice}
                            alt="login-side-img"
                            loading="lazy"
                            style={{ width: '100%', height: '70%', objectFit: 'cover' }}
                          />
                          <div
                            style={{
                              width: '100%',
                              height: '30%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'end',
                              alignItems: 'start',
                            }}
                          >
                            <p className="m-title" style={{ textAlign: 'left' }}>
                              Welcome to Accountizer! Where AI works for you, introducing you
                              precisely and correctly to clients.
                            </p>
                            <p className="sub-title" style={{ textAlign: 'left' }}>
                              Log in to streamline your workflow, manage your client relationships
                              effectively, and leverage innovative tools that simplify your
                              professional tasks.
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div style={{ width: '100%', height: '100%' }}>
                          <img
                            src={clientSignupChoice}
                            alt="login-side-img"
                            loading="lazy"
                            style={{ width: '100%', height: '70%', objectFit: 'cover' }}
                          />
                          <div
                            style={{
                              width: '100%',
                              height: '30%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'end',
                              alignItems: 'start',
                            }}
                          >
                            <p className="m-title" style={{ textAlign: 'left' }}>
                              Welcome to Accountizer! Where AI enhances your decision-making in
                              selecting accounting professionals.
                            </p>
                            <p className="sub-title" style={{ textAlign: 'left' }}>
                              Log In and let our technology help you decide the right match based on
                              the expertise and qualifications that are tailored to your needs.
                              Streamline your projects and manage your relationships with
                              professionals efficiently with our innovative task management tools.
                            </p>
                          </div>
                        </div>
                      )
                    ) : (
                      ''
                    )}
                  </div>
                )}
              {isSignupToggle &&
                (breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === 'xxl') && (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    className="login-side-img-container"
                  >
                    <div style={{ width: '100%', height: '100%' }}>
                      <img
                        style={{ width: '100%', height: '70%', objectFit: 'cover' }}
                        src={btnlist[0].value == 'linkedin' ? signupemaillinkedin : signupimg}
                        alt="login-side-img"
                        loading="lazy"
                      />
                      <div
                        style={{
                          width: '100%',
                          height: '30%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'end',
                          alignItems: 'start',
                        }}
                      >
                        {btnlist[0].value == 'linkedin' ? (
                          <>
                            <p className="m-title">Create Your Account</p>
                            <p className="sub-title">
                              Sign Up with your email or LinkedIn to get started. Whether you're
                              here to offer financial expertise or to find the right support, it
                              only takes a minute to join Accountizer.
                            </p>
                          </>
                        ) : (
                          <>
                            <p className="m-title">Choose Your Path</p>
                            <p className="sub-title">
                              Sign Up as a Client if you need expert help with taxes, bookkeeping,
                              budgeting, or any other personal or business financial matters.
                            </p>
                            <p className="sub-title">
                              Sign Up as an Expert if you're a qualified accountant, bookkeeper, tax
                              preparer, or finance professional ready to support individuals and
                              businesses.
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </Card>
          )}
        </Col>
      </Row>

      {showModal && (
        <VerifiedOTPModal
          visible={showModal}
          setVisible={() => {
            setShowModal(false);
          }}
        />
      )}
      {multiFactorAuth && (
        <Modal
          footer={null}
          title="Enter the 6-digit code sent to your email"
          open={multiFactorAuth}
          onCancel={() => setMultiFactorAuth(false)}
        >
          <Card className="shadow-lg rounded-2xl p-6 w-[350px] text-center">
            <div className="">
              <Input.OTP length={6} value={otp} onChange={value => setOtp(value)} />
            </div>
            <Space className="mt-6">
              <Button loading={isLoginLoading} disabled={isLoginLoading} type="primary" onClick={handleSubmit}>
                Verify OTP
              </Button>
            </Space>
          </Card>
        </Modal>
      )}
    </Parent>
  );
};

export default Login;
